import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import excel from 'vue-excel-export'

Vue.use(excel);
Vue.config.productionTip = false;

export const initialStore = {
    days: [],
    nboDays: 10,
    nboTeams: 6,
    currentDay: 1,
    dayStage: 'Supplier'
};

new Vue({
    router,
    render: h => h(App),
    data() {
        return {store: Object.assign({}, initialStore)}
    },
    mounted() {
        if (!this.load()) {
            //store initial value
            //console.log('saving initial app store to localStorage');
            this.save();
        }
        window.addEventListener("storage", this.onstorage);
    },
    watch: {
        store: {
            handler: function (val) {
                const serialized = JSON.stringify(val);
                localStorage.setItem('store', serialized);
                //console.log('store saved to localStorage on watch');
                //console.log('watch/currentDay = ' + this.store.currentDay);
            },
            deep: true
        }
    },
    computed: {
        hasNext() {
            return this.store.currentDay < this.store.nboDays;
        }
    },
    methods: {
        onstorage(event) {
            //window.storage event handler
            //console.log("onstorage event - key: " + event.key);
            if (event.key == 'store') {
                this.load(event.newValue);
            }
        },
        save() {
            const serialized = JSON.stringify(this.store);
            localStorage.setItem('store', serialized);
            //console.log('save/currentDay = ' + this.store.currentDay);
        },
        load(store_val) { // load from store localStorage or optional store_val json value
            if (!store_val)
                store_val = localStorage.getItem('store');
            if (store_val === null) {
                //no existing value saved
                //console.log('no saved store');
                return false;
            } else {
                this.$set(this, 'store', Object.assign({}, initialStore, JSON.parse(store_val)));
                //console.log('app store loaded from localStorage');
                //console.log('load/currentDay = ' + this.store.currentDay);
                return true;
            }
        }
    }
}).$mount('#app');
